module.exports = {"success":"Success","groupInfo":"Group Infomation","groupId":"You already Add this new Transaction to","next":"Next Step","back":"Back","backTo":"to Homepage","add":"Add","addTo":"Another Record","go":"Go","goTo":"to Settled Order, to edit group information"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/common/success.json
// module id = xh6r
// module chunks = 58